module.exports = __webpack_public_path__ + "img/legal1.85d6fe7c.png";